import Vue from 'vue';
import { API_HOST } from '../constants';

export default {
  get(params = {}) {
    return Vue.axios.get(`${API_HOST}/warehouse`, { params });
  },
  shippingTypes() {
    return Vue.axios.get(`${API_HOST}/shipping-type`);
  },
  redemptionCenter() {
    return Vue.axios.get(`${API_HOST}/redemption-center`);
  },
  overseas() {
    return Vue.axios.get(`${API_HOST}/overseas-warehouse`);
  },
};



// WEBPACK FOOTER //
// ./src/api/warehouse.js